export function invoiceReference(invoice) {
  const number = String(invoice?.invoice_number || '').trim();
  if (number) return number;
  const awb = String(invoice?.awb_number || '').trim();
  return awb ? `AWB ${awb}` : '—';
}

export function emptyAsDash(value) {
  return value === null || value === undefined || String(value).trim() === '' ? '—' : value;
}

export function invoiceItemCount(invoice) {
  return Array.isArray(invoice?.items) ? invoice.items.length : 0;
}

export function invoiceStemCount(invoice) {
  return (invoice?.items || []).reduce((sum, item) => sum + (Number(item.total_stems) || 0), 0);
}

export function invoiceGoodsTotal(invoice) {
  return (invoice?.items || []).reduce((sum, item) => sum + (Number(item.total_line) || 0), 0);
}

export function filterSavedInvoices(invoices, filters = {}) {
  const supplierId = String(filters.supplierId || '');
  const deliveryDate = String(filters.deliveryDate || '');
  const query = String(filters.query || '').trim().toLocaleLowerCase();

  return (invoices || []).filter(invoice => {
    if (supplierId && String(invoice.supplier_id) !== supplierId) return false;
    if (deliveryDate && String(invoice.delivery_date || '') !== deliveryDate) return false;
    if (query) {
      const number = String(invoice.invoice_number || '').toLocaleLowerCase();
      const awb = String(invoice.awb_number || '').toLocaleLowerCase();
      if (!number.includes(query) && !awb.includes(query)) return false;
    }
    return true;
  });
}
